import "@mdi/font/css/materialdesignicons.css";
import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import { fr, ar, en } from "vuetify/lib/locale";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: "#243742",
        secondary: "#747474",
        lightGrey: "#ECF4F9",
        lightGreen: "#BCE9D6",
        darkGreen: "#0D7147",
        lightRed: "#E9AAAA",
        darkRed: "#CC1414",
        accent: "#009EDF",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107"
      }
    }
  },
  lang: {
    locales: { fr, ar, en },
    current: "fr"
  }
});
